<p-dialog
  [header]="header"
  [(visible)]="visible"
  (onHide)="hideDialog($event)"
  (onShow)="showDialog($event)"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  [styleClass]="
    dialogSize === 'small'
      ? 'p-dialog-sm'
      : dialogSize === 'large'
      ? 'p-dialog-lg'
      : 'p-dialog-md'
  "
  appendTo="body"
>
  <ng-content></ng-content>
  <ng-template pTemplate="header">
    <ng-container *ngIf="headerTemplate">
      <ng-template *ngTemplateOutlet="headerTemplate"></ng-template>
    </ng-container>
  </ng-template>
  <ng-template #defaultFooter pTemplate="footer">
    <ng-container *ngIf="footerTemplate; else defaultFooter">
      <ng-template *ngTemplateOutlet="footerTemplate"></ng-template>
    </ng-container>
    <ng-template #defaultFooter>
      <div class="p-d-flex p-jc-center">
        <button
          *ngIf="showCancel"
          pButton
          type="button"
          label="{{ 'SigvLibrary.Cancel' | translate }}"
          (click)="cancelBtnClick($event)"
          class="p-button-secondary p-content-button p-mr-2"
        ></button>
        <button
          *ngIf="showConfirm"
          pButton
          type="button"
          label="{{ 'SigvLibrary.Ok' | translate }}"
          (click)="confirmBtnClick($event)"
          class="p-content-button"
        ></button>
      </div>
    </ng-template>
  </ng-template>
</p-dialog>
